import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { DuplicateObjectErrorItem } from 'src/app/core/models/core.models';

@Component({
  selector: 'app-business-constraints-info',
  standalone: false,
  templateUrl: './business-constraints-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './business-constraints-info.component.scss',
})
export class BusinessConstraintsInfoComponent {
  errors = input<DuplicateObjectErrorItem[]>([]);
}
